import { SxProps } from "@mui/material";

export const sxTypographyTelessaude: SxProps = {
    color: 'var(--Grey-Light-White, #fff)',
    fontFamily: 'Unimed-Sans',
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 'normal',
    '@media (max-width: 768px)': {
        fontSize: '24px',
    }
}

export const sxTypographyTelessaudeSubtitle: SxProps = {
    color: 'var(--Grey-Light-White, #fff)',
    fontFamily: 'Unimed-Sans',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '150%'
}

export const sxButtonTelessaudeAtendIngressar: SxProps = {
    borderRadius: '80px',
    height: '44px',
    padding: '24px 32px',
    '@media (max-width: 600px)': {
        width:'90%',
    }
}

export const sxButtonTelessaudeAtendValidarBiometria: SxProps = {
    borderRadius: '80px',
    height: '44px',
    padding: '24px 32px'
}

export const sxButtonTelessaudeAtendOutlined: SxProps = {
    borderRadius: '80px',
    height: '44px',
    border: '2px solid rgb(255 255 255)',
    padding: '24px 32px',
    color: 'white',
    '@media (max-width: 600px)': {
        width:'90%',
    }
}

export const sxTypographyValidateBiometricsTitle: SxProps = {
    color: 'var(--Grey-Light-White, #FFF)',
    textAlign: 'center',
    fontFamily: 'Unimed-Sans',
    fontSize: '20px',
    fontStyle: 'normal',
    width: '60%',
    fontWeight: 700,
    lineHeight: '150%',
    '@media (max-width: 767px)': {
        width: '100%'
    }
}

export const sxTypographyCameraCapture: SxProps = {
    color: 'var(--Grey-Light-White, #FFF)',
    textAlign: 'center',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    width: '50%',
    fontWeight: 700,
    lineHeight: '150%',
    '@media (max-width: 915px) or (max-height: 720px)': {
        width: '80%'
    },
    position: 'absolute',
    bottom: '5%',
    zIndex: '1'
}

export const sxTypographyValidateBiometricsDescription: SxProps = {
    color: 'var(--Grey-Light-White, #FFF)',
    textAlign: 'center',
    fontFamily: 'Unimed-Sans',
    width: '90%',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%'
}

export const sxTypographyQueueInfoTitle: SxProps = {
    color: 'var(--Grey-Light-White, #FFF)',
    textAlign: 'center',
    fontFamily: 'Unimed-Sans',
    fontSize: '20px',
    fontStyle: 'normal',
    width: '100%',
    fontWeight: 700,
    lineHeight: '150%'
}

export const sxTypographyQueueInfoDescription: SxProps = {
    color: 'var(--Grey-Light-White, #FFF)',
    textAlign: 'center',
    fontFamily: 'Unimed-Sans',
    width: '100%',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%'
}


export const sxTypographyQInfoTele: SxProps = {
    color: 'var(--Grey-Light-White, #5f5f5f)',
    textAlign: 'center',
    fontFamily: 'Unimed-Sans',
    width: '100%',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%'
}

export const sxTypographyValidateBiometricsWarning: SxProps = {
    color: 'var(--Grey-Light-White, #FFF)',
    textAlign: 'center',
    fontFamily: 'UnimedSans-Bold',
    fontSize: '16px',
    fontStyle: 'normal',
    lineHeight: '150%'
}

export const sxBodyBoldUnderline: SxProps = {
    color: 'var(--Grey-Light-White, #FFF)',
    fontfamily: 'UnimedSans-Bold',
    fontsize: '16px',
    textAlign: 'center',
    fontstyle: 'normal',
    lineheight: '150%',
    textDecoration: 'underline',
}

export const sxBodyCenter: SxProps = {
    color: 'var(--Grey-Light-White, #FFF)',
    fontfamily: 'Unimed-Sans',
    fontsize: '16px',
    textAlign: 'center',
    fontstyle: 'normal',
    lineheight: '150%',
}

export const sxDividerIngressarAtend: SxProps = {
    width: '50%',
    '@media (max-width: 1023px)': {
        width:'90%',
    },
    height: '1px',
    fill: 'none',
    backgroundColor: 'var(--Primary-03-Dark, #8FA8AF)',
    opacity: '0.5'
}

export const sxTypographyTitleModal: SxProps = {
    fontFamily: 'UnimedSans-Bold',
    textAlign: 'center',
    fontSize: '28px',
    marginBottom: '24px'
};
  
export const sxTypographySubTitleModal: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#5F5F5F',
    textAlign: 'center',
    marginBottom: '24px'
};

export const sxCloseIconButton: SxProps = {
    position: 'absolute',
    right: '24px',
    top: '24px',
    color: '#383838',
    '@media(max-width: 650px)': {
        right: '16px',
        top: '12px'
    }
}

export const sxButtonScheduleAction: SxProps = {
    borderRadius: '80px',
    height: '44px',
    padding: '24px 32px',
    '@media (max-width: 700px)': {
        width:'stretch',
    },
    '@media (min-width: 900px) and (max-width: 1180px)': {
        width:'stretch',
    }
}

export const sxButtonCameraCapture: SxProps = {
    borderRadius: '80px',
    height: '44px',
    padding: '24px 32px',
    '@media (max-width: 768px)': {
        width:'90%',
    }
}

export const sxButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px ',
    '@media (max-width: 1130px) and (max-height: 600px)': {
        marginLeft: '20px' 
    }
}

export const sxModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '481px',
    width: '85%',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px 48px',
    gap: '24px',
}

export const sxOutlinedButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    border: '2px solid var(--Primary-01-Medium, #00995D)',
    padding: '12px 32px ',
}

export const sxTryAgainButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    border: '2px solid var(--Primary-01-Medium, #00995D)',
    padding: '12px 32px ',
    backgroundColor: '#FFF',
    '@media (max-width: 768px)': {
        width:'90%',
    }
}

export const sxTextNoWrap: SxProps = {
    'textWrap': 'nowrap'
}